import * as React from 'react'

import createContext from 'modules/core/hooks/createContext'
import { useCallback } from 'modules/core/hooks/useCallback'

import type { SelectionDispatch } from './reducers/selection'
import selectionReducer, { SelectionState, initialSelectionState } from './reducers/selection'

const { context: SelectionStateContext, hook: useSelectionState } = createContext<SelectionState>()
const { context: SelectionDispatchContext, hook: useSelectionDispatch } =
  createContext<SelectionDispatch>()

const SelectionProvider = ({ children }: React.PropsWithChildren) => {
  const memoizedReducer = useCallback(selectionReducer, [])
  const [state, dispatch] = React.useReducer(memoizedReducer, initialSelectionState())

  return (
    <SelectionDispatchContext.Provider value={dispatch}>
      <SelectionStateContext.Provider value={state}>{children}</SelectionStateContext.Provider>
    </SelectionDispatchContext.Provider>
  )
}

export { SelectionProvider, useSelectionDispatch, useSelectionState }
